/** The name to show for an app: its catalog name when loaded, else its slug in words. */
const toAppName = ({ appSlug, apps = [] }) => {
  const match = apps.find((app) => app?.slug === appSlug);
  if (match?.name) {
    return match.name;
  }
  const words = String(appSlug || '')
    .split(/[-_\s]+/)
    .filter(Boolean);
  if (words.length === 0) {
    return 'The app';
  }
  return words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};

export default toAppName;
